import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import axios from "config/axios";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ViewCourseMap = () => {
  const [courseMaps, setCourseMaps] = useState([]);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedMap, setSelectedMap] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  // Fetch all course maps
  const fetchCourseMaps = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/courseMapSection/course-map-section`,
        // {
        //   // Disable caching
        //   headers: {
        //     "Cache-Control": "no-cache",
        //     Pragma: "no-cache",
        //     Expires: "0",
        //   },
        // }
      );
      setCourseMaps(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch course maps");
    }
  };

  useEffect(() => {
    fetchCourseMaps();
  }, []);

  const handleView = (map) => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/courseMapSection/${map._id}/course-map-section`;
    window.open(url, "_blank");
  };

  return (
    <div className="bg-white flex flex-col justify-center items-center">
      {/* View Section */}
      <div className="w-4/5 mt-10">
        <h2 className="text-2xl text-center font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight mb-3">
          View Course Map
        </h2>
        <div className="rounded overflow-hidden shadow-lg">
          <div className="px-6 py-4">
            {courseMaps && courseMaps.length > 0 ? (
              courseMaps.map((map) => (
                <div
                  key={map._id}
                  className="flex justify-between items-center mt-2 p-3 border rounded shadow-sm"
                >
                  {/* Left: Title */}
                  <span className="font-semibold">{map.title}</span>

                  {/* Right: Buttons */}
                  <div className="flex gap-2">
                    <button
                      className="bg-green-500 hover:bg-green-400 text-white font-bold py-2 px-4 border-b-4 border-green-700 hover:border-green-500 rounded"
                      onClick={() => handleView(map)}
                    >
                      View
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-gray-500">Course map uploading. Please wait...</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCourseMap;
